export interface IAllergenState {
    getAllergenDetails : any;
    getAllergenSuccessMessage : any;
    getAllergenErrorMessage : any;
    getEditAllergenSuccess : any;
    getEditAllergenError : any;
}

export const initialAllergenState : IAllergenState =  {
    getAllergenDetails : null,
    getAllergenSuccessMessage : null,
    getAllergenErrorMessage : null,
    getEditAllergenSuccess :null,
    getEditAllergenError :null,
}